<!-- components/common-header/index.vue -->
<script setup lang="ts">
import DesktopHeader from "./DesktopHeader.vue";
import MobileHeader from "./MobileMenu.vue";
import type { NavigationItem, ToggleParams } from "./type";

export interface CommonHeaderProps {
  logoPath?: string;
  logoAlt?: string;
  logoHeight?: string;
  logoText?: string;
  mainMenuItems?: NavigationItem[];
  loginPath?: string;
}

const props = withDefaults(defineProps<CommonHeaderProps>(), {
  logoPath: "@/assets/img/logo_column.png",
  logoAlt: "logo",
  logoHeight: "h-25 max-[800px]:h-15 md:h-15",
  logoText: "I C A A",
  loginPath: "/login",
  mainMenuItems: () => [],
});

const emit = defineEmits<{
  (e: "menu-click", item: NavigationItem): void;
  (e: "toggle", params: ToggleParams): void;
  (e: "logo-click"): void;
}>();

const handleMenuClick = (item: NavigationItem) => {
  emit("menu-click", item);
};

const handleToggle = (params: ToggleParams) => {
  emit("toggle", params);
};

const handleLogoClick = () => {
  emit("logo-click");
};
</script>

<template>
  <div class="common-header">
    <!-- 移动端导航 -->
    <MobileHeader
      :logo-path="logoPath"
      :logo-alt="logoAlt"
      :logo-height="logoHeight"
      :logo-text="logoText"
      :menu-items="mainMenuItems"
      :login-path="loginPath"
      @menu-click="handleMenuClick"
      @toggle="handleToggle"
      @logo-click="handleLogoClick"
    />

    <!-- 桌面端导航 -->
    <DesktopHeader
      :logo-path="logoPath"
      :logo-alt="logoAlt"
      :logo-height="logoHeight"
      :main-menu-items="mainMenuItems"
      :login-path="loginPath"
      @menu-click="handleMenuClick"
      @logo-click="handleLogoClick"
    />
  </div>
</template>

<style>
.common-header {
  --title-color: #373e43;
  --theme-color: #c57642;
  --white-color: #ffffff;
}
</style>
